export default "__VITE_ASSET__DgNRFxNY__"